import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(() => sessionStorage.getItem('adminToken') || null);

  useEffect(() => {
    if (token) {
      axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(r => setAdmin(r.data))
        .catch(() => { setToken(null); sessionStorage.removeItem('adminToken'); });
    }
  }, [token]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    setToken(data.token);
    setAdmin(data.admin);
    sessionStorage.setItem('adminToken', data.token);
    return data;
  };

  const logout = () => {
    setToken(null);
    setAdmin(null);
    sessionStorage.removeItem('adminToken');
  };

  const authHeader = token ? { Authorization: `Bearer ${token}` } : {};

  return (
    <AuthContext.Provider value={{ admin, token, loading, login, logout, authHeader, isAuthenticated: !!token }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
